import { Message as ElementMessage } from "element-ui";

let messageHandle = null;

function showMessage(options, type) {
  if (messageHandle) {
    messageHandle.close();
  }

  const messageOptions =
    typeof options === "string" ? { message: options } : options;
  messageHandle = ElementMessage({
    type,
    ...messageOptions
  });
}

const Message = {
  /**
   * 显示普通消息
   * @param {string | object} options 消息内容或配置对象
   */
  info(options) {
    showMessage(options, "info");
  },

  /**
   * 显示成功消息
   * @param {string | object} options 消息内容或配置对象
   */
  success(options) {
    showMessage(options, "success");
  },

  /**
   * 显示错误消息
   * @param {string | object} options 消息内容或配置对象
   */
  error(options) {
    showMessage(options, "error");
  }
};

export default Message;
